import api from "../apis/api";
import { handleEndCallFunc } from "../components/Twilio/Room/roomFunction";
import CustomToast from "../components/UI/customToast";
import reduxStore from "../configureEnvStore";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import { setConfirmDisconnectCall } from "../reducers/common-reducer";
import { LogFirebase } from "./firestore";
import storage from "./storage";

class EndCallService {
    endCallServiceFunction(req) {
        return api.endCallAPIFunction.endCall(req);
    }

    disconnectMWebDeepLinkUser() {
        api.endCallAPIFunction
            .disconnectMWebDeepLinkUser()
            .then((result) => {
                if (result) {
                    LogFirebase("disconnectUserRemotely", "disconnect_success", GLOBAL_MEETING_DATA.pid);
                }
            })
            .catch((err) => {
                if (err.message) {
                    LogFirebase("disconnectUserRemotely", "disconnect_error", err.message);
                    CustomToast.error(err.message);
                }
            });
    }

    confirmEndCall(popupOnDisconnect) {
        let showLeaveMsg = true;
        if (GLOBAL_MEETING_DATA.isAgent) {
            let agentsChoiceToShowPopup = storage.get("agentsChoiceToShowPopup");
            let agentChoiceObj = JSON.parse(agentsChoiceToShowPopup);
            LogFirebase("CallEndPopup", "agentsChoiceToShowPopup", agentChoiceObj);
            if (
                agentChoiceObj != null &&
                agentChoiceObj.hasOwnProperty(GLOBAL_MEETING_DATA.ucid) &&
                (agentChoiceObj[GLOBAL_MEETING_DATA.ucid] == "false" || agentChoiceObj[GLOBAL_MEETING_DATA.ucid] == false)
            ) {
                showLeaveMsg = false;
            }
        }
        if (popupOnDisconnect == true && showLeaveMsg) {
            reduxStore.dispatch(setConfirmDisconnectCall(true));
        } else {
            this.manageEndcall();
        }
    }

    manageEndcall() {
        PublicVariables.fromButton = true;
        handleEndCallFunc();
    }
}
export default new EndCallService();
